import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'

import { BootstrapVue } from 'bootstrap-vue'
import clientConfig from '/src/config/client';

import LifetimeIframeControl from '/src/config/LifetimeIframeControl.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: clientConfig.analytics.gacode,
  trackEvent: true,
  router,
  fields: {'cookieFlags': 'SameSite=None; Secure'}
})

Vue.use(VueGtag, {
  appName: 'Insurance Needs',
  pageTrackerScreenviewEnabled: true,
  config: {
    id: clientConfig.analytics.ga4code,
    params: {
      cookie_flags: 'SameSite=None;Secure',
      send_page_view: false
    }
  },
}, router)

Vue.use(BootstrapVue)

Vue.use(LifetimeIframeControl, {
  divId: "app",
  clientConfig: clientConfig
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
